export default function unionBy(arr, ...args) {
  let iteratee = args.pop();
  if (typeof iteratee === "string") {
    const prop = iteratee;
    iteratee = (item) => item[prop];
  }

  return arr.concat(...args).filter(function (item) {
    return item && !this.has(iteratee(item)) ? this.add(iteratee(item)) : false;
  }, new Set());
}
